import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'

/**
 * Component that syncs the i18n language with the caregiver's saved preference.
 * This should be rendered inside the Convex provider to have access to the settings query.
 * It renders nothing visually - it just handles the language sync side effect.
 */
export function LanguageSync() {
  const { i18n } = useTranslation()
  const settings = useQuery(api.settings.getSettings)

  useEffect(() => {
    // Only sync if we have settings and the language differs from current
    if (settings?.caregiver?.interfaceLanguage) {
      const savedLanguage = settings.caregiver.interfaceLanguage
      if (savedLanguage !== i18n.language) {
        i18n.changeLanguage(savedLanguage)
      }
    }
  }, [settings?.caregiver?.interfaceLanguage, i18n])

  // This component renders nothing - it's just for the side effect
  return null
}
